// Components==============
import { AnimatePresence, motion } from 'framer-motion';
import { useRootModal } from 'hooks/useRootModal';
import React, { useState } from 'react';
import { EvidenceState } from 'typings';
import { interactiveScale } from 'utilities/FramerAnimations';
import { getSmartImage } from 'utilities/getSmartImage';
import EvidenceModal from '../EvidenceModal/EvidenceModal';
import './EvidencePreview.module.scss';
// =========================

export default function EvidencePreview({
  evidence,
  handleDelete,
  deleteCondition,
  rootModal,
  disableComments = false,
  type,
}: {
  evidence: EvidenceEntity[];
  handleDelete?: (c: EvidenceState) => void;
  deleteCondition?: boolean;
  rootModal?: boolean;
  disableComments?: boolean;
  type?: 'assessment';
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { setModal } = useRootModal();

  const images = evidence.map((e) => e.path);

  const handleIndex = (i: number) => () => {
    setModal(
      <EvidenceModal
        evidence={evidence}
        handleDelete={handleDelete}
        deleteCondition={deleteCondition}
        disableComments={disableComments}
        canDeleteIfUserCreated
        initialImage={i}
      />
    );
  };

  function handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.stopPropagation();

    setModal(
      <EvidenceModal
        evidence={evidence}
        handleDelete={handleDelete}
        deleteCondition={deleteCondition}
        disableComments={disableComments}
        canDeleteIfUserCreated
      />
    );
  }
  return (
    <>
      <motion.button
        variants={type === 'assessment' ? undefined : interactiveScale}
        type="button"
        styleName="wrapper"
        onClick={(e) =>
          rootModal && type !== 'assessment'
            ? handleClick(e)
            : type !== 'assessment'
            ? setModalIsOpen(true)
            : null
        }
      >
        {type === 'assessment' ? (
          <div styleName="assessment">
            {evidence.map((e, i) => (
              <motion.div
                onClick={handleIndex(i)}
                {...interactiveScale}
                key={i}
              >
                {e?.path.includes('.mp4') ? (
                  <video styleName="assessment-video" preload="metadata">
                    <source src={`${e?.path}#t=0.5`} type="video/mp4" />
                  </video>
                ) : (
                  <img
                    styleName="assessment-image"
                    src={
                      e.type === 'extern'
                        ? `/images/cloud.png`
                        : getSmartImage(e.path)
                    }
                    alt={e.path}
                  />
                )}
              </motion.div>
            ))}
          </div>
        ) : (
          <>
            {evidence?.[0].path.includes('.mp4') ? (
              <video styleName="video" preload="metadata">
                <source src={`${evidence?.[0].path}#t=0.5`} type="video/mp4" />
              </video>
            ) : (
              <img
                styleName="image"
                src={
                  evidence[0].type === 'extern'
                    ? `/images/cloud.png`
                    : getSmartImage(images[0])
                }
                alt={images[0]}
              />
            )}
            {images.length > 1 && (
              <div styleName="count">{`+${images.length - 1}`}</div>
            )}
          </>
        )}
      </motion.button>
      <AnimatePresence>
        {modalIsOpen && (
          <EvidenceModal
            setModalIsOpen={setModalIsOpen}
            evidence={evidence}
            handleDelete={handleDelete}
            deleteCondition={deleteCondition}
            canDeleteIfUserCreated
            disableComments={disableComments}
          />
        )}
      </AnimatePresence>
    </>
  );
}
